import React, { useEffect, useState } from "react";
import ReusableTable from "../../../../components/common/table";
import { Button, Popconfirm, Space } from "antd";
import { ReactComponent as AddSvg } from "../../../../assets/images/add.svg";
import FilterComponent from "../../../../components/common/filter";
import { useNavigate } from "react-router";
import ConfirmModal from "../../../../components/common/alert-popup";
import { ReactComponent as ViewSvg } from "../../../../assets/images/action/view.svg";
import { ReactComponent as DeleteSvg } from "../../../../assets/images/action/delete.svg";
import { ReactComponent as EditSvg } from "../../../../assets/images/action/edit.svg";
import { ReactComponent as DisableSvg } from "../../../../assets/images/action/Shield Cross.svg";
import CommonFilter from "../../../../components/common/filter";
import { deletePodcastCategory, listPodcastCategory, updatePodcastCategory } from "../../../../redux/reducer/PodcastCategorySlice";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { useDebounce } from "../../../../customHooks";
import { useSearchParams } from "react-router-dom";
import trimSearchValue from "../../../../customHooks";

const ManageCategory = () => {
  const [filteredData, setFilteredData] = useState(null);
  const navigate = useNavigate();
  const [refereshData, setRefereshData] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [disableId, setDisableId] = useState(null);
  const [disableStatus, setDisableStatus] = useState(null)
  const [currentPage, setCurrentPage] = useState(1);
  
// const [tableParams, setTableParams] = useState({
//   page: 1,
//   size: 10,
//   search_value: "",
//   search_key: "",
//   status: undefined,
//   position: undefined,
// });

  // set page refersh 
  const [searchParams, setSearchParams] = useSearchParams();
  // Convert URLSearchParams to usable object
const getInitialParams = () => {
  const page = parseInt(searchParams.get("page")) || 1;
  const size = parseInt(searchParams.get("size")) || 10;
  const search_key = searchParams.get("search_key") || "all";
  const search_value = searchParams.get("search_value") || "";
  const status = searchParams.get("status");
  const type = searchParams.get("type");
  const position = searchParams.get("position");

  return {
    page,
    size,
    search_key,
    search_value,
    status: status !== null ? Number(status) : undefined,
    type: type !== null ? Number(type) : undefined,
    position: position !== null ? Number(position) : undefined,
  };
};

const [tableParams, setTableParams] = useState(getInitialParams());

useEffect(() => {
  const params = {
    page: tableParams.page,
    size: tableParams.size,
    search_key: tableParams.search_key,
    search_value: tableParams.search_value,
  };

  if (tableParams.status !== undefined) params.status = tableParams.status;
  if (tableParams.type !== undefined) params.type = tableParams.type;
  if (tableParams.position !== undefined) params.position = tableParams.position;

  setSearchParams(params);
}, [tableParams, setSearchParams]);

  // set page refersh end

  const [modalConfig, setModalConfig] = useState({
    open: false,
    actionType: "",
  });

  const dispatch = useDispatch()
  const {listPodcastCategorydata, listPodcastCategoryCount, listPodcastCategoryLoading} = useSelector(prev => prev?.podcastCategory);


  const debouncedSearchValue = useDebounce(tableParams.search_value, 500);

// pagination


const handleTableChange = (pagination) => {
  setTableParams((prev) => ({
    ...prev,
    page: pagination.current,
    size: pagination.pageSize,
  }));
};

// pagination end


  useEffect(()=>{

    // setTableParams((prev)=> ({...prev, search_value:  }))
    dispatch(listPodcastCategory(trimSearchValue(tableParams)))
  },[dispatch, refereshData,
    tableParams.page, tableParams.size,
    debouncedSearchValue,
    tableParams.status,
    tableParams.type,
    tableParams.position,
  ])

  

  const showModal = (actionType) => {
    setModalConfig({ open: true, actionType });
  };

  const closeModal = () => {
    setModalConfig({ open: false, actionType: "" });
  };

 
  const handleSearch = (searchText) => {
    const filtered = dataSource.filter((item) =>
      item.tenant_name.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: (text, record, index) => (tableParams.page - 1) * tableParams.size + index + 1, 
      width: "100px"
    },
    { 
      title: "Category Name",
      dataIndex: "name_en",
      key: "category_name",
      type: "search",
    },
    {
      title: "Category Type",
      dataIndex: "type",
      key: "category_name",
      type: "select",
      width: "130px",
      render: (type) =>(
        type === 1 ? "Category"  : type === 2 ? "Collection" :  "Product"
      ),
      options: [
        { label: "Category", value: 1 },
        { label: "Product", value: 0 },
        { label: "Collection", value: 2 },
       ],
    },
    {
      title: "Image",
      dataIndex: "icon",
      key: "banner_media",
      render: (icon) => (
        <div>
          {icon ? (
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}/${icon}`}
              alt="Banner"
              style={{ width: "100px", height: "50px", objectFit:"contain", borderRadius: "8px" }}
            />
          ) : (
            "No Image"
          )}
        </div>
      ),
    },
    {
      title: "Date Added",
      dataIndex: "created_at",
      key: "date_added",
      // type: "date",
      // render: (date) => dayjs(date).format("MM-DD-YYYY"),
      render: (date) => {
        const dateObject = new Date(date);
        const day = String(dateObject.getUTCDate()).padStart(2, '0');       
        const month = String(dateObject.getUTCMonth() + 1).padStart(2, '0'); 
        const year = dateObject.getUTCFullYear();                          
        return `${month}-${day}-${year}`;
      },
    },
    {
      title: "No. Of Podcasts",
      dataIndex: "total_podcast",
      key: "nos_podcast",
      // type: "search",
      width: "200px",
      render: (total_podcast) => total_podcast ?? "0",
    },
    {
      title: "Sequence",
      dataIndex: "sequence",
      key: "sequence",
      width: "120px"
      // type: "search",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      type: "select",
      width: "90px",
      render: (status) => (status === 1 ? <p className="active-status">Active</p> : <p className="inactive-status">Inactive</p>), // Check if status is 1
      options: [
        { label: "Active", value: 1 },
        { label: "Inactive", value: 0 },
       ],
    },
  ];

  const dataSource = [
    {
      key: "1",
      sr_no: "1",
      category_name: "Acme Corp",
      podcast_added: 50,
      status: "Active",
      date_added: "2024-02-15",
    },
    {
      key: "2",
      sr_no: "2",
      category_name: "Tech Solutions",
      podcast_added: 120,
      status: "Inactive",
      date_added: "2023-05-10",
    },
    {
      key: "3",
      sr_no: "3",
      category_name: "Innovate Inc.",
      podcast_added: 80,
      status: "Active",
      date_added: "2024-03-01",
    },
  ];

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    showModal("delete"); // Open the modal
  };

  const handleConfirm = async () => {
    try {
      if (modalConfig.actionType === "delete" && deleteId) {
        await dispatch(deletePodcastCategory(deleteId));
      } else if (modalConfig.actionType === "disable" && disableId) {
        await dispatch(updatePodcastCategory({ id: disableId, data: { status: 0 } }));     
      }else if (modalConfig.actionType === "enable"){
        await dispatch(updatePodcastCategory({ id: disableId, data: { status: 1 } }));
      }

    } catch (error) {
      console.error("Action failed:", error);
    }finally{
      setRefereshData((prev) => !prev);
      setDisableId(null);
    }
    closeModal();
  };

  const handleDisableClick = (id, status) => {
    if(status === 1){
      showModal("disable", id, status)
    }else if(status === 0){
      showModal("enable", id, status)
    } else{
      
    }    
    setDisableStatus(status)
    setDisableId(id);
  };

  const actionItems = (record) =>  [
    {
      key: "edit",
      label: (
        <>
          <EditSvg style={{ marginRight: 8, color: "red" }} />
          Edit Details
        </>
      ),
      onClick: (record) => navigate("add-category", { state: { editData: record } }),
 
    },
    {
      key: "disable",
      label: (
        <>
           <DisableSvg style={{ marginRight: 8, color: `${record.status === 1 ? "green" : "red" }`}} />
         {record.status === 1 ?   "Disable": "Enable"}
        </>
      ),
      onClick: (record) => handleDisableClick(record.id, record?.status),
   
    },
    {
      key: "delete",
      label: (
        <>
          <DeleteSvg style={{ marginRight: 8, color: "red" }} />
          Delete Category
        </>
      ),
      onClick: (record) => handleDeleteClick(record.id), 
    },
  ];

  


const paginationConfig = {
  pageSizeOptions: ["10", "20", "50"], 
  showSizeChanger: true, 
  showQuickJumper: true, 
  total: listPodcastCategoryCount || 1, 
  current: tableParams.page, 
  pageSize: tableParams.size, 
  type: tableParams.type,
  onChange: (page, pageSize) => {
    // setCurrentPage(page); 
    setTableParams((prev) => ({ ...prev, page, size: pageSize }));
  },
};


  const handleFilterChange = (key, value, reset = false) => {

    
    setTableParams((prev) => {
      if (reset) {
        return {
          ...prev,
          search_key: "",
          search_value: "",
          status: undefined,
          position: undefined,
          
        };
      }
      else if (key === "status" || key==="type" || key === "position") {
        return {
          ...prev,
          [key]: [0, 1, 2].includes(value) ? value : undefined,
          search_key: undefined,
          search_value: undefined,
        };
      }
      return {
        ...prev,
        search_key: key,
        search_value: value,
        status: undefined,
        position: undefined,
      };
    });
  };
  return (
    <div>
      <div className="addBx">
        <div className="filterBx">
          <Space>
            <CommonFilter
              columns={columns}
              onFilterChange={handleFilterChange}
              searchValue={tableParams.search_value}
              // status={tableParams.status}
              // position={tableParams.position}
            />
          </Space>
        </div>
        <Button
          type="primary"
          icon={<AddSvg />}
          onClick={() => navigate("add-category")}
        >
          Add Category
        </Button>
      </div>
      <div className="tableHeading">List of Category Added</div>
      <ReusableTable
        columns={columns}
        dataSource={listPodcastCategorydata}
        loading={listPodcastCategoryLoading}
        paginationConfig={paginationConfig}
        onChange={handleTableChange}
        actionItems={(record) => actionItems(record)}
      />
      <ConfirmModal
        titlePrefix="Category"
        messagePrefix="Category"
        open={modalConfig.open}
        onClose={closeModal}
        onConfirm={handleConfirm}
        actionType={modalConfig.actionType}
      />
    </div>
  );
};

export default ManageCategory;

